// apps/web/src/pages/coletor/kanban-tablet/tablet-pausar-sheet.tsx — Fase 11, Plano 15 (KAN-07, D-20).
import { useState, type ReactElement } from 'react';
import type { KanbanMotivo } from '@pieltec/contracts';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '../../../components/ui/sheet';
import { validarPausa } from '../../../lib/kanban/tablet';

const OUTRO = 'OUTRO';

export interface TabletPausarSheetProps {
  aberto: boolean;
  motivos: readonly KanbanMotivo[];
  enviando: boolean;
  erro: string | null;
  onFechar: () => void;
  onConfirmar: (input: { tipoInterrupcaoId?: string; motivoOutro?: string }) => void;
}

export function TabletPausarSheet({
  aberto,
  motivos,
  enviando,
  erro,
  onFechar,
  onConfirmar,
}: TabletPausarSheetProps): ReactElement {
  const [selecionado, setSelecionado] = useState<string>('');
  const [outro, setOutro] = useState<string>('');
  const [validacao, setValidacao] = useState<string | null>(null);

  function confirmar(): void {
    const ehOutro = selecionado === OUTRO;
    const mensagem = validarPausa({
      tipoInterrupcaoId: selecionado && !ehOutro ? selecionado : undefined,
      outro: ehOutro ? outro : undefined,
    });
    setValidacao(mensagem);
    if (mensagem) return;
    onConfirmar(ehOutro ? { motivoOutro: outro.trim() } : { tipoInterrupcaoId: selecionado });
  }

  return (
    <Sheet open={aberto} onOpenChange={(v) => (!v ? onFechar() : undefined)}>
      <SheetContent side="bottom" className="bg-slate-900 text-slate-100 border-slate-700 p-5" data-density="touch">
        <SheetHeader>
          <SheetTitle className="text-xl text-white">Pausar — informe o motivo</SheetTitle>
          <SheetDescription className="text-slate-400">O cartão volta a poder ser iniciado depois.</SheetDescription>
        </SheetHeader>

        <div className="space-y-4">
          <select
            aria-label="Motivo da pausa"
            value={selecionado}
            onChange={(e) => {
              setSelecionado(e.target.value);
              setValidacao(null);
            }}
            className="w-full min-h-[64px] px-4 bg-slate-950 border border-slate-700 rounded-xl text-base text-white focus:ring-2 focus:ring-emerald-400"
          >
            <option value="">Selecione um motivo</option>
            {motivos.map((m) => (
              <option key={m.id} value={m.id}>
                {m.nome}
              </option>
            ))}
            <option value={OUTRO}>Outro</option>
          </select>

          {selecionado === OUTRO && (
            <textarea
              aria-label="Descreva o motivo"
              value={outro}
              onChange={(e) => {
                setOutro(e.target.value);
                setValidacao(null);
              }}
              placeholder="Descreva o motivo (obrigatório)"
              rows={3}
              className="w-full px-4 py-3 bg-slate-950 border border-slate-700 rounded-xl text-base text-white focus:ring-2 focus:ring-emerald-400"
            />
          )}

          {(validacao || erro) && (
            <p className="text-sm text-red-300" role="alert">
              {validacao ?? erro}
            </p>
          )}

          <div className="flex gap-3">
            <button
              type="button"
              onClick={onFechar}
              className="min-h-[64px] px-6 bg-slate-800 hover:bg-slate-700 border border-slate-600 text-slate-100 font-bold text-base rounded-xl touch-manipulation"
            >
              Cancelar
            </button>
            <button
              type="button"
              disabled={enviando}
              onClick={confirmar}
              className="min-h-[64px] flex-1 bg-amber-600 hover:bg-amber-500 disabled:opacity-50 text-white font-bold text-base rounded-xl touch-manipulation"
            >
              Pausar
            </button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
